import styled from "styled-components";

export const WxdhDetailStyle = styled.div`
@font-face {
  font-family: 'dingliesongtypeface';
  src: url('https://cdn-prd.ggac.com/ggac/font/dingliesongtypeface20241217.ttf');
}
@font-face {
    font-family: 'SourceHanSerifCN';
    src: url('https://cdn-prd.ggac.com/ggac/font/SourceHanSerifCN-Medium.otf');
}
.detail {
    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-bg.jpg") center center no-repeat;
    background-size: 100% 100%;
    font-family: 'dingliesongtypeface';
    padding: 100px 0 0;
    margin-top: -5px;
    .title-wrap {
        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 35px;
            position: relative;
            .title-word {
                font-size: 50px;
                span {
                    font-size: 60px;
                }
                div {
                    background: linear-gradient(180deg, #fefcfb 0%, #ffeba9 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    -webkit-text-fill-color: transparent;
                }
            }
            .left,.right {
                height: 22px;
            }
        }
        .num {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -10px;
            width: 55px;
        }
        .en-word {
            font-size: 12px;
	        letter-spacing: 18px;
            padding-left: 18px;
	        color: #ffffff;
	        opacity: 0.4;
            text-align: center;
            font-family: 'SourceHanSerifCN';
            margin-top: -10px;
        }
    }

    .part1 {
        position: relative;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-one-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1286 / 536;
            margin: 50px auto 0;
            padding-top: 50px;
            .word {
                text-align: center;
                font-size: 21px;
	            line-height: 30px;
	            color: #fffffe;
                &:nth-child(2n - 1) {
                    margin-top: 20px;
                }
                span {
                    color: #ffe79a;
                }
            }
            .wordTip {
                text-align: center;
                width: 568px;
	            border-radius: 21px;
	            border: solid 1px #fff3ce;
                margin: 30px auto 0;
                line-height: 42px;
                font-size: 18px;
                color: #ffe79a;
            }
        }
        .icon1 {
            position: absolute;
            left: 0;
            bottom: -250px;
            width: 250px;
        }
        .icon2 {
            position: absolute;
            right: 0;
            width: 200px;
            bottom: -100px;
        }
    }

    .part2 {
        margin-top: 180px;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1200 / 512;
            margin: 50px auto 0;
            padding-top: 50px;
            display: flex;
            justify-content: space-around;
            padding: 0 100px;
            position: relative;
            .item {
                background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-border2.png") center center no-repeat;
                width: 177px;
                aspect-ratio: 177 / 333;
                height: max-content;
                margin-top: 90px;
                font-size: 28px;
                color: #301513;
                padding-top: 115px;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    width: 203px;
                    height: 12px;
                    margin-bottom: 25px;
                }
                .date {
                    font-family: 'SourceHanSerifCN';
                    height: 63px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    gap: 3px;
                    div {
                        font-size: 20px;
                    }
                    & div:nth-child(2) {
                        writing-mode: sideways-rl;
                        font-size: 24px;
                    }
                }
            }
            .tree {
                position: absolute;
                right: -43px;
                bottom: 44px;
            }
        }
    }

    .part3 {
        margin-top: 175px;
        .prize-content {
            display: flex;
            margin-top: 60px;
            .prize-item {
                background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-border.png") center center no-repeat;
                background-size: 100% 100%;
                width: 753px;
                height: 147px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 70px;
                .name {
                    color: #ffe79a;
                    font-size: 37px;
                }
                .money-icon {
                    width: 79px;
                    height: 101px;
                }
                .money {
                    font-family: 'SourceHanSerifCN';
                    span {
                        color: #ffe79a;
                        font-size: 49px;
                        line-height: 40px;
                    }
                    span:first-child {
                        font-size: 34px;
                        margin-left: -5px;
                    }
                    span:nth-child(3) {
                        font-size: 23px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .prize-content2 {
            width: 1200px;
            margin: 50px auto 0;
            gap: 50px;
            .prize-item {
                background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-border2.png") center center no-repeat;
                background-size: 100% 100%;
                width: 265px;
                height: 322px;
                flex-direction: column;
                gap: 20px;
                .name {
                    font-size: 28px;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    img {
                        width: 15px;
                        height: 17px;
                    }
                }
            }
        }
    }

    .part4 {
        margin-top: 140px;
        position: relative;
        .judge {
            display: flex;
            justify-content: center;
            width: 1200px;
            margin: 60px auto 0;
            flex-wrap: wrap;
            gap: 140px;
            &-item {
                padding-top: 146px;
                .judge-content {
                    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-judge-border.png") center center no-repeat;
                    width: 248px;
                    aspect-ratio: 248 / 410;
                    background-size: 100% 100%;
                    position: relative;
                    padding-top: 150px;
                    text-align: center;
                    .cover {
                        position: absolute;
                        left: 50%;
                        top: 0;
                        transform: translate(-50%, -50%);
                        width: 286px;
                        aspect-ratio: 286 / 289;
                    }
                    .name {
                        font-size: 30px;
	                    color: #ffe79a;
                        margin-bottom: 20px;
                    }
                    .desc {
                        font-size: 18px;
	                    line-height: 26px;
	                    color: #fefefe;
                    }
                }
            }
        }
        .icon3 {
            position: absolute;
            right: 0;
            top: 55%;
            transform: translateY(-50%);
            width: 250px;
        }
    }
    
    .part5 {
        margin-top: 140px;
        .evaluationCriteria {
            display: flex;
            justify-content: center;
            gap: 50px;
            margin-top: 60px;
            .evaluation {
                background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-part5-border.png") center center no-repeat;
                width: 263px;
                aspect-ratio: 263 / 336;
                background-size: 100% 100%;
                padding-top: 40px;
                text-align: center;
                &:last-child {
                    .name {
                        font-size: 24px;
                    }
                }
                .name {
                    font-size: 28px;
	                color: #ffe79a;
                    margin-bottom: 40px;
                }
                .desc {
                    font-size: 18px;
	                line-height: 28px;
	                color: #fefefe;
                }
            }
        }
    }

    .part6 {
        margin-top: 140px;
        position: relative;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part6-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1360px;
            aspect-ratio: 1460 / 650;
            margin: 50px auto 0;
            padding-top: 50px;
            display: flex;
            justify-content: space-around;
            padding: 0 100px;
            position: relative;
            .item {
                background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part6-border3.png") center center no-repeat;
                background-size: 100% 100%;
                width: 210px;
                aspect-ratio: 221 / 441;
                height: max-content;
                margin-top: 85px;
                font-size: 28px;
                color: #301513;
                padding-top: 150px;
                display: flex;
                flex-direction: column;
                align-items: center;
                .name {
                    margin-bottom: 30px;
                }
                &:first-child,&:nth-child(4) {
                    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part6-border2.png") center center no-repeat;
                    background-size: 100% 100%;
                    width: 210px;
                    aspect-ratio: 221 / 396;
                    padding-top: 105px;
                    margin-top: 100px;
                    .name {
                        margin-bottom: 30px;
                    }
                }
                .desc {
                    font-size: 17px;
	                line-height: 26px;
	                color: #502d2b;
                }
            }
        }
        .tree {
            position: absolute;
            right: -70px;
            bottom: 50px;
        }
        .icon4 {
            position: absolute;
            left: 0;
            bottom: 100px;
            width: 200px;
        }
    }
    
    .part7 {
        margin-top: 140px;
        .rule {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part7-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1220 / 996;
            margin: 50px auto 0;
            padding: 80px 75px 0;
            &-item {
               display: flex;
               font-size: 20px;
	           line-height: 25px;
	           color: #ffffff;
               gap: 10px;
               margin-bottom: 15px;
            }
        }
    }

    .bottom {
        text-align: center;
        margin-top: 100px;
        .bottom-logo {
            width: 600px;
        }
        &-tree {
            display: flex;
            justify-content: space-between;
            width: 100%;
            img {
                width: 550px;
            }
        }
    }
}
`